import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { ApolloProvider } from '@apollo/client'
import shortid from 'shortid'

import SpectrumProvider from '@react/react-spectrum/Provider'

import { RootContextProvider } from './RootContext'

import { DndProvider as ReactDndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

import App from '../views/App'
import Install from 'views/Install'
import Project from '../views/Project'
import Projects from '../views/Projects'

import { PATHS } from '../config/constants'
import { initializeFontLibrary } from '../config/fontAwesome'
import A from '../services/analytics'
import apolloClient from '../services/apolloClient'

import './SpectrumOverrides.scss'

// Initialize shortid charset to replace '-' with '$'
shortid.characters('0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_$')

// Initialize Data Layer for Analytics
A.init()

// Initialize FontAwesome library of icons
initializeFontLibrary()

function Root() {
  return (
    <ApolloProvider client={apolloClient}>
      <SpectrumProvider theme='light' scale='medium'>
        <BrowserRouter basename={PATHS.BASE}>
          <RootContextProvider>
            <ReactDndProvider backend={HTML5Backend}>
              <App>
                <Switch>
                  <Route exact path={PATHS.PROJECT_LIST} component={Projects} />
                  <Route path={`${PATHS.PROJECT_DETAILS}:projectId/:tab?`} component={Project} />
                  <Route path={`${PATHS.INSTALL}`} component={Install} />
                  <Route path={PATHS.HOME} component={Projects} />
                </Switch>
              </App>
            </ReactDndProvider>
          </RootContextProvider>
        </BrowserRouter>
      </SpectrumProvider>
    </ApolloProvider>
  )
}

export default Root
